var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOutIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20H27.7778M27.7778 20L24.4444 23.3334M27.7778 20L24.4444 16.6667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20H27.7778M27.7778 20L24.4444 23.3334M27.7778 20L24.4444 16.6667",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7777 13.3333V12.2222C27.7777 10.9949 26.7828 10 25.5555 10H14.4444C13.2171 10 12.2222 10.9949 12.2222 12.2222V27.7778C12.2222 29.0051 13.2171 30 14.4444 30H25.5555C26.7828 30 27.7777 29.0051 27.7777 27.7778V26.6667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7777 13.3333V12.2222C27.7777 10.9949 26.7828 10 25.5555 10H14.4444C13.2171 10 12.2222 10.9949 12.2222 12.2222V27.7778C12.2222 29.0051 13.2171 30 14.4444 30H25.5555C26.7828 30 27.7777 29.0051 27.7777 27.7778V26.6667",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOutIcon);
export default __webpack_public_path__ + "static/media/sign-out-icon.d340ece885f25a7f4afc4fdf55aa99b8.svg";
export { ForwardRef as ReactComponent };